export default {
	token: '',
	status: false,
	statusValue: false
};
